// Third Party Imports
import React from 'react';

// HA Artifactory Imports
import FormSelect from '@homeaway/react-form-select';

// Relative Imports
import ContinueButtonHolder from '../ButtonHolder/ContinueButtonHolder';
import AlertBox from '../Alert/Alert';
import './BrandDetermination.less';

class BrandDetermination extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }


    getCurrencyListItems = () => {
        const {translations, supportedCurrenciesAndSites} = this.props;
        let items = [{label: '', value: ''}];

        if(supportedCurrenciesAndSites && Object.keys(supportedCurrenciesAndSites).length > 0){
            Object.keys(supportedCurrenciesAndSites).forEach((key) => {
                items.push({
                    label: `${translations[`ipmob.brand_determination.currency.${key}`]}`,
                    value: key
                });
            });
        }

        return items;
    }

    getLanguageSiteListItems = () => {
        const {translations, supportedCurrenciesAndSites, currency} = this.props;
        const selectedCurrencySites = supportedCurrenciesAndSites[currency] || [];
        let items = [{label: '', value: ''}];

        if(selectedCurrencySites && selectedCurrencySites.length > 0){
            selectedCurrencySites.map((e) => {
                items.push({
                    label: translations[`ipmob.brand_determination.language_site.${e.name}`],
                    value: e.name
                });
            });
        }

        return items;
    }

    renderCurrencyComponent = () => {
        const {
                currency,
                translations,
                handleCurrencyChange,
                handleCurrencyOnBlur,
                currencyError
            } = this.props;
        
        return (<div>
                    <div className="wrapper">
                        <div className="content-col-text sub-head">
                            <h3>{translations['ipmob.brand_determination.sub_heading_1']}</h3>
                        </div>
                    </div>
                    <div className="wrapper">
                        <div className="content-col-text">
                            <div className="desc">{translations['ipmob.brand_determination.sub_heading_1.desc']}</div>
                        </div>
                    </div>
                    <div className="wrapper">
                        <div className="content-col">
                            <FormSelect
                                id="currencySelection"
                                name="Currency selected"
                                items={this.getCurrencyListItems()}
                                label={translations['ipmob.currency']}
                                value={currency}
                                onChange={handleCurrencyChange}
                                errorMsg={translations[currencyError]}
                                onBlur={handleCurrencyOnBlur}
                            />
                        </div>
                    </div>
               </div>)
    }

    renderLanguageSiteComponent = () => {
        const {
                translations,
                currency,
                handlePrimarySiteOnBlur,
                supportedCurrenciesAndSites,
                handlePrimarySiteChange,
                primarySite,
                primarySiteError
            } = this.props;
        return (
            <div className="input-container" aria-label="Big form">
                { 
                    currency &&
                    currency.length > 0 &&
                    supportedCurrenciesAndSites &&
                    supportedCurrenciesAndSites[currency].length === 1 ? 
                    (
                        <div>
                            <div className="wrapper">
                                <div className="content-col-text sub-head">
                                    <h3>{translations['ipmob.language']}</h3>
                                </div>
                            </div>
                            <div className="wrapper">
                                <div className="content-col-text">
                                    <div className="desc">
                                        {translations[`ipmob.brand_determination.language_site.${supportedCurrenciesAndSites[currency][0].name}`]}
                                        {currency === 'USD' ? ` ${translations['ipmob.brand_determination.language_site.vrbo.us_postfix']}` : ''}
                                        {currency === 'CAD' ? ` ${translations['ipmob.brand_determination.language_site.vrbo.ca_postfix']}` : ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                     :
                    ( 
                        <div className="wrapper">
                            <div className="content-col">
                                <FormSelect
                                    id="primarySite"
                                    name="Language"
                                    items={this.getLanguageSiteListItems()}
                                    label={translations['ipmob.language']}
                                    value={primarySite?.name || ''}
                                    onChange={handlePrimarySiteChange}
                                    errorMsg={translations[primarySiteError]}
                                    onBlur={handlePrimarySiteOnBlur}
                                />
                            </div>
                        </div>
                    )
                }
            </div>
        );
    }


    render() {
        const {
            translations,
            serviceError,
            handleAlertDismiss,
            enableContinueButton,
            enableBackButton,
            handleFormSubmit,
            handleBackButtonClick,
            currency
        } = this.props;

        return (
            <div id="brandDetermination" className="brand-determination">
                <div className="brand-determination-container">
                    <div className="form-col">
                        {(serviceError) ? (
                            <div className="alert-panel">
                                <AlertBox
                                    messageKey={serviceError}
                                    translations={translations}
                                    handleAlertDismiss={handleAlertDismiss}
                                    size={'sm'}
                                />
                            </div>
                        ) : null}

                        <div className="wrapper">
                            <div className="content-col-text panel-head">
                                <h1 className="head">{translations['ipmob.brand_determination.heading_1']}</h1>
                            </div>
                        </div>
                        <div className="wrapper">
                            <div className="content-col-text head">
                                <div className="desc">{translations['ipmob.brand_determination.heading_1.desc']}</div>
                            </div>
                        </div>
                        <form role="form" onSubmit={handleFormSubmit}>
                            { this.renderCurrencyComponent() }
                            { currency && currency.length > 0 ?
                                this.renderLanguageSiteComponent() : null
                            }
                            <ContinueButtonHolder
                                enableContinueButton={enableContinueButton}
                                handleContinueButtonClick={handleFormSubmit}
                                translations={translations}
                                enableBackButton={enableBackButton}
                                handleBackButtonClick={handleBackButtonClick}
                                continueButtonId={'brandDeterminationContinueBtn'}
                            />
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default BrandDetermination;
